import {Request} from "../../../core/utils/request";

export const AdminPanelSubsAPI = {
    getSubscriptionsByUserId: (userId: string) => {
        return Request.get(`super-admin/user/${userId}/subscription`)
    }
}
